import { useUserStore } from '../stores/userStore';
import { clearCurrentUser } from './currentUser';

// Auth0 error codes meaning the cached session can no longer produce an access
// token: the refresh token is gone (missing_refresh_token), expired, revoked or
// rotated away (invalid_grant), or Auth0 wants an interactive login.
const SESSION_EXPIRED_AUTH0_ERRORS = new Set([
    'missing_refresh_token',
    'invalid_grant',
    'login_required',
]);

export function isSessionExpiredError(error: unknown): boolean {
    const code = (error as { error?: unknown } | null)?.error;
    return typeof code === 'string' && SESSION_EXPIRED_AUTH0_ERRORS.has(code);
}

/**
 * Wipes everything the app keeps for the signed-in user, including the Auth0
 * SDK cache in localStorage. The form id and cookie consent survive so the user
 * lands back on the same form after logging in again.
 */
export function clearLocalSession(): void {
    try {
        const encryptedSimpleFormId = localStorage.getItem(
            'encryptedSimpleFormId',
        );
        const cookieConsent = localStorage.getItem('cookieConsent');
        localStorage.clear();
        if (encryptedSimpleFormId) {
            localStorage.setItem(
                'encryptedSimpleFormId',
                encryptedSimpleFormId,
            );
        }
        if (cookieConsent) {
            localStorage.setItem('cookieConsent', cookieConsent);
        }
    } catch {
        // Storage unavailable — Auth0's logout clears its own cache anyway.
    }
    // Clear the in-memory user store so the next login (potentially as a different
    // account) triggers a fresh fetch instead of serving the previous user's data.
    useUserStore.getState().reset();
    clearCurrentUser();
}
